import React from "react";
import ProductAddedPopInBody from "./ProductAddedPopInBody";
import AddToCartError from "./AddToCartError";

const ProductAddedPopInContent = (props) => {
  return (
    <div className="product-added">
      <AddToCartError />
      <ProductAddedPopInBody
        sku={props.product.sku}
        name={props.product.name}
        prices={props.product.prices}
        imageUrl={props.product.imageUrl}
      />
    </div>
  );
};

export default ProductAddedPopInContent;
